export default __webpack_public_path__ + "static/media/finops_logo.dde181cd.png";